import { FormConfirmDialog } from "@/components/FormConfirmDialog";

import { BranchEditor } from "./BranchEditor";

import type { BranchEditorState } from "./BranchEditor";
import type { Control } from "react-hook-form";

type BranchEditorDialogProps = {
  open: boolean;
  title: string;
  onClose: () => void;
  onSubmit: () => void | PromiseLike<void>;
  loading: boolean;
  control: Control<BranchEditorState>;
};

export function BranchEditorDialog({
  open,
  title,
  onClose,
  onSubmit,
  loading,
  control,
}: BranchEditorDialogProps) {
  return (
    <FormConfirmDialog
      control={control}
      title={title}
      loading={loading}
      open={open}
      onClose={onClose}
      onConfirm={onSubmit}
    >
      <BranchEditor control={control} />
    </FormConfirmDialog>
  );
}
